import { ArrowUpDownIcon } from 'lucide-react';

import { useTranslation } from '@nucleus-commerce/i18n/react';
import { Button } from '@nucleus-commerce/ui/components/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@nucleus-commerce/ui/components/dropdown-menu';

import type { PickerSortOption } from './types';

export interface ResourcePickerSortProps {
  options: readonly PickerSortOption[];
  value: string | undefined;
  onChange: (value: string) => void;
}

/** The sort menu at the end of the picker's filter row: "Sort: Title A–Z". */
export function ResourcePickerSort({ options, value, onChange }: ResourcePickerSortProps) {
  const { t } = useTranslation('common');
  const current = options.find((option) => option.value === value) ?? options[0];
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="h-7 px-2 text-xs font-normal"
          aria-label={t('resourcePicker.sortLabel', { label: current?.label ?? '' })}
        >
          <ArrowUpDownIcon aria-hidden />
          {current?.label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" onCloseAutoFocus={(event) => event.preventDefault()}>
        <DropdownMenuLabel>{t('resourcePicker.sort')}</DropdownMenuLabel>
        <DropdownMenuRadioGroup value={current?.value} onValueChange={onChange}>
          {options.map((option) => (
            <DropdownMenuRadioItem key={option.value} value={option.value}>
              {option.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
